import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      isShown: false,
      isLoaded: false,
    };
  },

  computed: {
    ...mapState('myAccount', ['menuLinks']),

    ...mapState('currentUser', ['isLogged']),

    panelOptions() {
      return {
        onShow: () => this.onShow(),
      };
    },
  },

  methods: {
    ...mapActions('currentUser', ['loadCustomerInfo']),

    onShow() {
      this.isShown = true;
    },
  },

  watch: {
    async isShown(value) {
      if (value) {
        await this.loadCustomerInfo(true);
        this.isLoaded = true;
      }
    },
  },
};
